<nz-tag [nzColor]="backgroundColor" [ngStyle]="{'border-color': borderColor}">
  <img src="assets/{{icon}}" >
  <span [ngStyle]="{'color': textColor}">{{label}}</span>
</nz-tag>